import { useDispatch, useSelector } from 'react-redux';
import '../css/app.css'
import '../css/common.css'
import '../css/payment.css'
import { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { change_Current_Location, changeHeaderTitle } from '../../store';
import axios from 'axios';
import { MessageModal } from '../component/modal/modal';
import bank from '../bankList'

import { CountAmount, CountAmountLeft, CountSelect, DownloadBtn, TotalAmount } from '../component/btn/btn';
import List from '../component/list/list';
import { LoadingModal } from '../component/modal/modal';

import * as FileSaver from "file-saver";
import * as XLSX from "xlsx";

import { SquareX, SquareCheck, X } from 'lucide-react';

import Litepicker from 'litepicker';
import 'litepicker/dist/css/litepicker.css';
import { SearchDate, SearchRange, SearchSelect, SearchSelectText, SearchBtn, SearchCrteateBtn, SearchExcelBtn, SearchInputBtn } from '../component/search/search';
import { useLocation, useNavigate } from 'react-router-dom';
import Select from 'react-select';
import dayjs from 'dayjs';

import { changeNum, convertDateFormat } from '../common/function';

function SugiListManage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const MyData = useSelector((state) => state.MyData);

    const [page, setPage] = useState(1);
    const [maxFirstPage, setMaxFirstPage] = useState(20);
    const [loading, setLoading] = useState(true);
    const [message, setMessage] = useState("");
    const [listData, setListData] = useState([]);
    const [cancelListData, setCancelListData] = useState([]);

    const [combineData, setCombineData] = useState([]);
    const [combineList, setCombineList] = useState([]);
    const [cancelCombineData, setCancelCombineData] = useState([]);
    const [cancelCombineList, setCancelCombineList] = useState([]);

    const [reload, setReload] = useState(false);
    const [activeTab, setActiveTab] = useState("수기결제");
    const [listState, setListState] = useState(false);

    const inputRef = useRef(null);
    const pickerRef = useRef(null);

    const [preDate, setPreDate] = useState(dayjs().format("YYYY-MM-DD"));
    const [nextDate, setNextDate] = useState(dayjs().format("YYYY-MM-DD"));

    // ─────────────────────────────────────────────
    // 모바일 / PC 구분 (화면 너비 767 이하이면 모바일)
    // ─────────────────────────────────────────────
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 767);
        }
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // ─────────────────────────────────────────────
    // 드롭다운 / 모달 관련 상태
    // ─────────────────────────────────────────────
    const [goodsDropdownOpen, setGoodsDropdownOpen] = useState(false);
    const [dropdownPos, setDropdownPos] = useState({ top: 0, left: 0 });
    const [goodsList, setGoodsList] = useState([]);
    const [goodsInput, setGoodsInput] = useState("");
    const [currentRowId, setCurrentRowId] = useState(null);
    const dropdownRef = useRef(null);

    // ─────────────────────────────────────────────
    // 초기 설정
    // ─────────────────────────────────────────────
    useEffect(() => {
        dispatch(change_Current_Location("수기결제승인내역"));
        dispatch(
            changeHeaderTitle({
                mainTitle: "수기결제승인내역",
            })
        );
        setTimeout(() => {
            setLoading(false);
        }, 500);
    }, [dispatch]);

    useEffect(() => {
        if (location?.state) {
            setActiveTab(location?.state?.tab ?? "수기결제");
        }
    }, [location]);

    // ─────────────────────────────────────────────
    // 날짜 선택
    // ─────────────────────────────────────────────
    useEffect(() => {
        pickerRef.current = new Litepicker({
            element: inputRef.current,
            lang: "ko",
            singleMode: false,
            format: "YYYY-MM-DD",
            numberOfMonths: 2,
            numberOfColumns: 2,
            showWeekNumbers: true,
            dropdowns: {
                minYear: 2020,
                maxYear: 2030,
                months: true,
                years: true,
            },
            setup: (picker) => {
                picker.on("selected", (start, end) => {
                    setPreDate(start.format("YYYY-MM-DD"));
                    setNextDate(end.format("YYYY-MM-DD"));
                });
            },
        });
        return () => {
            pickerRef.current?.destroy();
        };
    }, []);

    useEffect(() => {
        setDateRange(dayjs().format("YYYY-MM-DD"), dayjs().format("YYYY-MM-DD"));
    }, []);

    const setDateRange = (startDate, endDate) => {
        setPreDate(startDate);
        setNextDate(endDate);
        pickerRef.current?.setDateRange(startDate, endDate);
        onSubmitSearch();
    };

    const onSubmitSearch = () => {
        setPage(1);
        setReload((e) => !e);
    };

    // ─────────────────────────────────────────────
    // 리스트 호출
    // ─────────────────────────────────────────────
    useEffect(() => {
        ListData();
        CancelListData();
    }, [reload]);

    // ================================
    // 수기결제 리스트
    // ================================
    const ListData = async () => {
        try {
            const response = await axios.get(process.env.REACT_APP_API + "/api/sugi/admin", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                const withGoodsName = tmp?.data?.map((item) => ({
                    ...item,
                    GoodsName: item.GoodsName || "",
                }));
                setListData(withGoodsName ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ================================
    // 수기결제취소 리스트
    // ================================
    const CancelListData = async () => {
        try {
            const response = await axios.get(
                process.env.REACT_APP_API + "/api/sugi/cancel/list/admin",
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                const withGoodsName = tmp?.data?.map((item) => ({
                    ...item,
                    GoodsName: item.GoodsName || "",
                }));
                setCancelListData(withGoodsName ?? []);
                setListState((e) => !e);
            } else if (tmp?.code === 9999) {
                navigate("/");
            }
        } catch (error) {
            console.error(error);
            navigate("/");
        }
    };

    // ─────────────────────────────────────────────
    // 드롭다운(또는 모달) 열기
    // ─────────────────────────────────────────────
    const openGoodsDropdown = async (rowId, e) => {
    setCurrentRowId(rowId);
    await fetchGoodsList(); // 상품 목록 가져오기

    if (!isMobile) {
        const rect = e.target.getBoundingClientRect();
        let newLeft = rect.left + window.scrollX - 200;

        // 화면이 1920보다 클 경우, 중앙 정렬 보정값을 빼줌
        const screenWidth = window.innerWidth;
        const layoutWidth = 1920;
        const offset = screenWidth > layoutWidth ? (screenWidth - layoutWidth) / 2 : 0;
        newLeft -= offset;

        let newTop = rect.bottom + window.scrollY + 5;
        setDropdownPos({ top: newTop, left: newLeft });
    }

    setGoodsDropdownOpen(true);
};


    // ─────────────────────────────────────────────
    // 드롭다운 위치 보정 (PC 전용)
    // ─────────────────────────────────────────────
    useEffect(() => {
        if (goodsDropdownOpen && !isMobile) {
            // 다음 tick(렌더링) 후 위치 측정
            requestAnimationFrame(() => {
                if (!dropdownRef.current) return;
                const ddRect = dropdownRef.current.getBoundingClientRect();
                let { top, left } = dropdownPos;

                // 우측 / 하단 화면 밖 체크
                if (ddRect.right > window.innerWidth) {
                    const overflowX = ddRect.right - window.innerWidth + 10;
                    left -= overflowX;
                }
                if (ddRect.bottom > window.innerHeight) {
                    const overflowY = ddRect.bottom - window.innerHeight + 10;
                    top -= overflowY;
                }
                // 최소값 보정
                if (left < 0) left = 10;
                if (top < 0) top = 10;

                setDropdownPos({ top, left });
            });
        }
    }, [goodsDropdownOpen, dropdownPos, isMobile]);

    // ─────────────────────────────────────────────
    // 드롭다운 / 모달 닫기
    // ─────────────────────────────────────────────
    const closeGoodsDropdown = () => {
        setGoodsDropdownOpen(false);
        setCurrentRowId(null);
        setGoodsInput("");
    };

    // ─────────────────────────────────────────────
    // 외부 클릭 감지 => 닫기
    // (PC일 때만 드롭다운 닫기, 모바일 모달에서도 작동 가능)
    // ─────────────────────────────────────────────
    useEffect(() => {
        function handleClickOutside(e) {
            if (
                goodsDropdownOpen &&
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target)
            ) {
                closeGoodsDropdown();
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [goodsDropdownOpen]);

    // ─────────────────────────────────────────────
    // 상품 조회/추가/삭제
    // ─────────────────────────────────────────────
    const fetchGoodsList = async () => {
        try {
            let response = await axios.get(process.env.REACT_APP_API + "/api/goods", {
                withCredentials: true,
            });
            let tmp = response?.data;
            if (tmp.code < 2000) {
                setGoodsList(tmp.data ?? []);
            }
        } catch (e) {
            console.error(e);
        }
    };

    const addGoods = async () => {
        if (!goodsInput.trim()) {
            alert("상품명을 입력하세요.");
            return;
        }
        try {
            let res = await axios.post(
                process.env.REACT_APP_API + "/api/goods",
                { goods_name: goodsInput.trim() },
                { withCredentials: true }
            );
            if (res.data.code < 2000) {
                setGoodsInput("");
                fetchGoodsList();
            }
        } catch (e) {
            console.error(e);
        }
    };

    const deleteGoods = async (id) => {
        if (!window.confirm("상품을 삭제하시겠습니까?")) return;
        try {
            let res = await axios.post(
                process.env.REACT_APP_API + "/api/goods/delete",
                { id },
                { withCredentials: true }
            );
            if (res.data.code < 2000) {
                fetchGoodsList();
            }
        } catch (e) {
            console.error(e);
        }
    };

    // ─────────────────────────────────────────────
    // 상품 선택 => 행 데이터에 GoodsName 세팅
    // ─────────────────────────────────────────────
    const handleGoodsSelect = (name) => {
        const newList = [...listData];
        const idx = newList.findIndex((item) => item.id === currentRowId);
        if (idx > -1) {
            newList[idx].GoodsName = name;
        }
        setListData(newList);
        closeGoodsDropdown();
    };

    // ================================
    // 승인 / 거절 / 취소승인 / 취소거절
    // ================================
    const onSubmitData = async (found) => {
        if (!window.confirm("수기결제 승인요청을 승인하시겠습니까?")) return;
        try {
            let metadataObj = {};
            try {
                metadataObj = JSON.parse(found?.metadata || "{}");
            } catch (e) {
                console.error(e);
            }

            const rawCardNumber = (found?.req_card_number ?? "").replace(/\D/g, "");
            const amtVal = String(found?.req_amount ?? "").replace(/\D/g, "");
            const finalGoodsName = found.GoodsName || "상품명미지정";

            const body = {
                id: found.id,
                mid: found?.co_nm || "",
                payerName: found?.req_payer_name || "",
                payerEmail: found?.req_payer_email || "",
                payerTel: (found?.req_payer_tel ?? "").replace(/\D/g, ""),
                cardNumber: rawCardNumber,
                cardExpiry:
                    found?.req_card_expiry?.slice(0, 2) +
                    found?.req_card_expiry?.slice(2, 4),
                cardCvv: found?.req_card_cvv || "",
                installment: found?.req_installment || "00",
                products: [
                    {
                        prodId: "",
                        name: finalGoodsName,
                        qty: 1,
                        price: amtVal,
                        desc: "수기결제",
                    },
                ],
                metadata: {
                    cardAuth: "true",
                    authPw: metadataObj?.authPw || "",
                    authDob: metadataObj?.authDob || "",
                },
                amount: amtVal,
            };

            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/confirm",
                body,
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 승인 요청 실패" });
            }
        } catch (error) {
            console.error(error);
            setMessage({ msg: "승인 요청 중 오류가 발생했습니다." });
        }
    };

    const onDeleteData = async (id) => {
        if (!window.confirm("수기결제 승인요청을 거절하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/reject",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onCancelSubmitData = async (id, riskId) => {
        if (!window.confirm("수기결제 취소승인요청을 승인하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/confirm",
                { id, riskId },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제 취소승인 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    const onCancelDeleteData = async (id) => {
        if (!window.confirm("수기결제 취소승인요청을 거절하시겠습니까?")) return;
        try {
            const response = await axios.post(
                process.env.REACT_APP_API + "/api/sugi/cancel/reject",
                { id },
                { withCredentials: true }
            );
            let tmp = response?.data;
            if (tmp?.code < 2000) {
                setReload((e) => !e);
            } else {
                setMessage({ msg: "수기결제요청 거절 실패" });
            }
        } catch (error) {
            console.error(error);
        }
    };

    // ================================
    // 테이블 헤더 (수기결제)
    // ================================
    const tableHeaderData = [
        { no: 1, text: "상태", width: "70px", textAlign: "center" },
        { no: 2, text: "시간", width: "60px", textAlign: "center" },
        { no: 3, text: "에이전트", width: "170px", textAlign: "center" },
        { no: 4, text: "가맹점", width: "170px", textAlign: "center" },
        { no: 5, text: "금액", width: "80px", textAlign: "center" },
        { no: 6, text: "상품", width: "120px", textAlign: "center" },
        { no: 7, text: "승인", width: "70px", textAlign: "center" },
        { no: 8, text: "비고", width: "150px", textAlign: "center" },
        { no: 9, text: "거절", width: "70px", textAlign: "center" },
    ];

    // ================================
    // 테이블 헤더 (수기결제취소)
    // ================================
    const tableHeaderData1 = [
        { no: 1, text: "상태", width: "70px", textAlign: "center" },
        { no: 2, text: "시간", width: "60px", textAlign: "center" },
        { no: 3, text: "가맹점", width: "170px", textAlign: "center" },
        { no: 4, text: "금액", width: "80px", textAlign: "center" },
        { no: 5, text: "승인", width: "70px", textAlign: "center" },
        { no: 6, text: "승인번호", width: "70px", textAlign: "center" },
        { no: 7, text: "거절", width: "70px", textAlign: "center" },
        { no: 8, text: "비고", width: "150px", textAlign: "center" },
    ];

    // ================================
    // "수기결제" 테이블
    // ================================
    useEffect(() => {
        let tableBodyData = [];
        if (listData) {
            setCombineList(listData);

            for (let i = 0; i < listData.length; i++) {
                let data = listData[i];

                let goodsCell = (
                    <div
                        style={{
                            textDecoration: "underline",
                            cursor: "pointer",
                            color: "#3182F6",
                        }}
                        onClick={(e) => openGoodsDropdown(data.id, e)}
                    >
                        {data.GoodsName && data.GoodsName.length > 0
                            ? data.GoodsName
                            : "상품선택"}
                    </div>
                );

                let rowData = [
                    {
                        no: 1,
                        text: data.status,
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 2,
                        text: getDisplayTime(data.reg_date),
                        width: "60px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.name,
                        width: "170px",
                        textAlign: "left",
                    },
                    {
                        no: 4,
                        text: data.co_nm,
                        width: "170px",
                        textAlign: "left",
                    },
                    {
                        no: 5,
                        text: changeNum(data.req_amount),
                        width: "80px",
                        textAlign: "right",
                    },
                    {
                        no: 6,
                        text: goodsCell,
                        width: "120px",
                        textAlign: "center",
                    },
                    {
                        no: 7,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                <a
                                    className="delete flex items-center text-success pointer"
                                    onClick={() => onSubmitData(data)}
                                >
                                    <SquareCheck width={15} height={15} /> 승인
                                </a>
                            </div>
                        ),
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 8,
                        text: data.desc,
                        width: "150px",
                        textAlign: "left",
                    },
                    {
                        no: 9,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                <a
                                    className="delete flex items-center text-danger pointer"
                                    onClick={() => onDeleteData(data.id)}
                                >
                                    <SquareX width={15} height={15} /> 거절
                                </a>
                            </div>
                        ),
                        width: "70px",
                        textAlign: "center",
                    },
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setCombineData(tableBodyData);
            setListState((e) => !e);
        }
    }, [listData]);

    // ================================
    // "수기결제취소" 테이블
    // ================================
    useEffect(() => {
        let tableBodyData = [];
        if (cancelListData) {
            setCancelCombineList(cancelListData);

            for (let i = 0; i < cancelListData.length; i++) {
                let data = cancelListData[i];

                let rowData = [
                    {
                        no: 1,
                        text: data.status,
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 2,
                        text: getDisplayTime(data.created_at),
                        width: "60px",
                        textAlign: "center",
                    },
                    {
                        no: 3,
                        text: data.co_nm,
                        width: "170px",
                        textAlign: "left",
                    },
                    {
                        no: 4,
                        text: changeNum(data.amt),
                        width: "80px",
                        textAlign: "right",
                    },
                    {
                        no: 5,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                <a
                                    className="delete flex items-center text-success pointer"
                                    onClick={() => onCancelSubmitData(data.id, data.riskId)}
                                >
                                    <SquareCheck width={15} height={15} /> 승인
                                </a>
                            </div>
                        ),
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 6,
                        text: data.approval_id,
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 7,
                        text: (
                            <div
                                className="flex justify-center items-center"
                                style={{ gap: "15px" }}
                            >
                                <a
                                    className="delete flex items-center text-danger pointer"
                                    onClick={() => onCancelDeleteData(data.id)}
                                >
                                    <SquareX width={15} height={15} /> 거절
                                </a>
                            </div>
                        ),
                        width: "70px",
                        textAlign: "center",
                    },
                    {
                        no: 8,
                        text: data.desc,
                        width: "150px",
                        textAlign: "left",
                    },
                ];
                rowData.id = data.id;
                tableBodyData.push(rowData);
            }
            setCancelCombineData(tableBodyData);
            setListState((e) => !e);
        }
    }, [cancelListData]);

    // 탭 전환
    const handleClickTab = (tabName) => {
        setActiveTab(tabName);
    };

    const tabList = ["수기결제", "수기결제취소"];

    // 경과 시간 표시
    const getDisplayTime = (regDate) => {
        const now = new Date();
        const dateObj = new Date(regDate);
        const kstDate = new Date(dateObj.getTime() + 9 * 60 * 60 * 1000);
        const diffMs = now - kstDate;

        const diffMinutes = Math.floor(diffMs / 1000 / 60);
        const diffHours = Math.floor(diffMinutes / 60);
        const diffDays = Math.floor(diffHours / 24);

        if (diffMinutes < 60) return `${diffMinutes}분`;
        if (diffHours < 24) return `${diffHours}시간`;
        return `${diffDays}일`;
    };

    return (
        <div className="content" id="contents" style={{ position: "relative" }}>
            {loading ? <LoadingModal /> : null}
            <MessageModal message={message} />

            <div className="form_filter intro-y">
                <form id="tabulator-html-filter-form">
                    <SearchDate
                        type={"기간"}
                        inputRef={inputRef}
                        setDateRange={setDateRange}
                        preDate={preDate}
                        nextDate={nextDate}
                        isDisabled={true}
                    />
                </form>
            </div>

            <div
                className="intro-y box intro-padding"
            >
                {/* 탭 버튼 */}
                <div
                    style={{
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        borderBottom: "1px solid #E5E5E5",
                        backgroundColor: "#fff",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tabList.map((tab) => (
                            <button
                                key={tab}
                                className={`tab-btn ${activeTab === tab ? "active" : ""}`}
                                onClick={() => handleClickTab(tab)}
                                style={{
                                    padding: "12px 10px 8px",
                                    fontSize: "14px",
                                    fontWeight: activeTab === tab ? "600" : "400",
                                    color: activeTab === tab ? "#222" : "#888",
                                    background: "transparent",
                                    border: "none",
                                    borderBottom:
                                        activeTab === tab
                                            ? "3px solid #3182F6"
                                            : "3px solid transparent",
                                    transition: "all 0.2s ease-in-out",
                                    cursor: "pointer",
                                }}
                            >
                                {tab}
                            </button>
                        ))}
                    </div>
                </div>

                {/* 수기결제 탭 */}
                {activeTab === "수기결제" ? (
                    <div className="div-flex-2 contents" style={{ gap: "20px" }}>
                        <div style={{ width: "100%", maxWidth: "1000px" }}>
                            <List
                                tableHeaderData={tableHeaderData}
                                tableBodyData={combineList ?? []}
                                filter_tableBodyData={combineData}
                                page={page}
                                setPage={setPage}
                                maxFirstPage={maxFirstPage}
                                listType={true}
                                listState={listState}
                                nonePage={false}
                            />
                        </div>
                    </div>
                ) : (
                    // 수기결제취소 탭
                    <div style={{ width: "100%", maxWidth: "800px" }}>
                        <List
                            tableHeaderData={tableHeaderData1}
                            tableBodyData={cancelCombineList ?? []}
                            filter_tableBodyData={cancelCombineData}
                            page={page}
                            setPage={setPage}
                            maxFirstPage={maxFirstPage}
                            listType={true}
                            listState={listState}
                            nonePage={false}
                        />
                    </div>
                )}
            </div>

            {/* 
                PC 화면 => 드롭다운, 
                모바일(<=767) => 모달 
            */}
            {goodsDropdownOpen && (
                isMobile ? (
                    // =============================
                    // 모바일: 중앙 모달 형태
                    // =============================
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100vw",
                            height: "100vh",
                            backgroundColor: "rgba(0,0,0,0.5)",
                            zIndex: 9999,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={closeGoodsDropdown}
                    >
                        <div
                            ref={dropdownRef}
                            style={{
                                width: "90%",
                                maxWidth: "400px",
                                backgroundColor: "#fff",
                                borderRadius: "8px",
                                padding: "20px",
                                position: "relative",
                            }}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {/* 모달 헤더 */}
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <h2 style={{ fontSize: "18px", margin: 0 }}>상품 선택</h2>
                                <div
                                    style={{
                                        cursor: "pointer",
                                        color: "#999",
                                    }}
                                    onClick={closeGoodsDropdown}
                                >
                                    <X size={22} />
                                </div>
                            </div>
                            {/* 등록 영역 */}
                            <div
                                style={{
                                    display: "flex",
                                    gap: "10px",
                                    marginBottom: "10px",
                                    height: "35px",
                                    fontSize: "13px",
                                }}
                            >
                               <input
                                    type="text"
                                    className="custom-input"
                                    placeholder="상품명 입력"
                                    value={goodsInput}
                                    onChange={(e) => setGoodsInput(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") addGoods();
                                    }}
                                    style={{
                                        flex: 1,
                                        border: "1px solid #ccc",
                                        padding: "0px 10px",
                                        borderRadius: "4px",
                                        fontSize: "16px"
                                    }}
                                />
                                <button
                                    onClick={addGoods}
                                    style={{
                                        backgroundColor: "#3182F6",
                                        color: "#fff",
                                        padding: "0px 10px",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                    }}
                                >
                                    등록
                                </button>
                            </div>
                            {/* 상품 목록 */}
                            <div
                                style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                }}
                            >
                                {(() => {
                                    const chunkedGoodsList = [];
                                    for (let i = 0; i < goodsList.length; i += 2) {
                                        chunkedGoodsList.push(goodsList.slice(i, i + 2));
                                    }

                                    if (chunkedGoodsList.length === 0) {
                                        return (
                                            <div
                                                style={{
                                                    textAlign: "center",
                                                    margin: "10px 0",
                                                    color: "#666",
                                                }}
                                            >
                                                등록된 상품이 없습니다.
                                            </div>
                                        );
                                    }

                                    return chunkedGoodsList.map((rowItems, rowIndex) => (
                                        <div
                                            key={rowIndex}
                                            style={{
                                                display: "flex",
                                                borderBottom: "1px solid #eee",
                                                padding: "6px 0",
                                                gap: "10px",
                                            }}
                                        >
                                            {rowItems.map((item) => (
                                                <div
                                                    key={item.id}
                                                    style={{
                                                        flex: 1,
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    {/* 상품명 */}
                                                    <div
                                                        style={{
                                                            cursor: "pointer",
                                                            width: "calc(100% - 20px)",
                                                            overflow: "hidden",
                                                            textOverflow: "ellipsis",
                                                            whiteSpace: "nowrap",
                                                            fontSize: "15px",
                                                        }}
                                                        onClick={() =>
                                                            handleGoodsSelect(item.goods_name)
                                                        }
                                                    >
                                                        {item.goods_name}
                                                    </div>
                                                    {/* 빨간 X (삭제) */}
                                                    <div
                                                        onClick={() => deleteGoods(item.id)}
                                                        style={{
                                                            cursor: "pointer",
                                                            color: "#b91c1c",
                                                            marginLeft: "10px",
                                                            flexShrink: 0,
                                                        }}
                                                    >
                                                        <X size={18} />
                                                    </div>
                                                </div>
                                            ))}
                                            {/* 홀수개 처리 */}
                                            {rowItems.length === 1 && <div style={{ flex: 1 }}></div>}
                                        </div>
                                    ));
                                })()}
                            </div>
                        </div>
                    </div>
                ) : (
                    // =============================
                    // PC : 드롭다운
                    // =============================
                    <div
                        ref={dropdownRef}
                        style={{
                            position: "absolute",
                            top: dropdownPos.top,
                            left: dropdownPos.left,
                            width: "355px",
                            backgroundColor: "#fff",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            padding: "10px",
                            zIndex: 9999,
                            boxShadow: "rgba(0, 0, 0, 0.04) 0px 0.25rem 0.5rem",
                            border: "2px solid #dfdfdf",
                        }}
                    >
                        {/* 헤더 영역 (상품 선택, 닫기) */}
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <h2 style={{ fontSize: "16px" }}>상품 선택</h2>
                            <div
                                style={{
                                    cursor: "pointer",
                                    fontSize: "18px",
                                    color: "#999",
                                    marginLeft: "10px",
                                }}
                                onClick={closeGoodsDropdown}
                            >
                                <X size={20} />
                            </div>
                        </div>

                        {/* 등록 영역 (엔터키 등록) */}
                        <div
                            style={{
                                display: "flex",
                                gap: "10px",
                                marginBottom: "10px",
                                height: "30px",
                                fontSize: "13px",
                            }}
                        >
                            <input
                                type="text"
                                placeholder="상품명 입력"
                                value={goodsInput}
                                onChange={(e) => setGoodsInput(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") addGoods();
                                }}
                                style={{
                                    flex: 1,
                                    border: "1px solid #ccc",
                                    padding: "0px 10px",
                                    borderRadius: "4px",
                                    fontSize: "13px",
                                }}
                            />
                            <button
                                onClick={addGoods}
                                style={{
                                    backgroundColor: "#3182F6",
                                    color: "#fff",
                                    padding: "0px 10px",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                등록
                            </button>
                        </div>

                        {/* 상품 목록 스크롤 영역 */}
                        <div
                            style={{
                                maxHeight: "200px",
                                overflowY: "auto",
                            }}
                        >
                            {(() => {
                                const chunkedGoodsList = [];
                                for (let i = 0; i < goodsList.length; i += 2) {
                                    chunkedGoodsList.push(goodsList.slice(i, i + 2));
                                }

                                if (chunkedGoodsList.length === 0) {
                                    return (
                                        <div
                                            style={{
                                                textAlign: "center",
                                                margin: "10px 0",
                                                color: "#666",
                                            }}
                                        >
                                            등록된 상품이 없습니다.
                                        </div>
                                    );
                                }

                                return chunkedGoodsList.map((rowItems, rowIndex) => (
                                    <div
                                        key={rowIndex}
                                        style={{
                                            display: "flex",
                                            borderBottom: "1px solid #eee",
                                            padding: "5px 0",
                                            gap: "10px",
                                        }}
                                    >
                                        {rowItems.map((item) => (
                                            <div
                                                key={item.id}
                                                style={{
                                                    flex: 1,
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    alignItems: "center",
                                                }}
                                            >
                                                {/* 상품명 */}
                                                <div
                                                    style={{
                                                        cursor: "pointer",
                                                        width: "calc(100% - 20px)",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        fontSize: "13px",
                                                    }}
                                                    onClick={() =>
                                                        handleGoodsSelect(item.goods_name)
                                                    }
                                                >
                                                    {item.goods_name}
                                                </div>
                                                {/* 빨간 X (삭제) */}
                                                <div
                                                    onClick={() => deleteGoods(item.id)}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#b91c1c",
                                                        marginLeft: "10px",
                                                        flexShrink: 0,
                                                    }}
                                                >
                                                    <X size={16} />
                                                </div>
                                            </div>
                                        ))}
                                        {/* 홀수개 처리 */}
                                        {rowItems.length === 1 && <div style={{ flex: 1 }}></div>}
                                    </div>
                                ));
                            })()}
                        </div>
                    </div>
                )
            )}
        </div>
    );
}

export default SugiListManage